module.exports = __webpack_public_path__ + "img/fb.23322d06.svg";